import { FC } from 'react';
import './Intro.scss';
import { InteractiveTourProps } from '../InteractiveTourProps';
import { useInteractiveTourContext } from '../InteractiveTourContext';
import PublicImage from '../../PublicImage';

const Intro: FC<InteractiveTourProps> = ({ content }) => {
  const { setCurrentSlide, setShowIntro } = useInteractiveTourContext();

  const handleButtonClick = (newSlide: string) => {
    setCurrentSlide(newSlide);
    setShowIntro(false);
  };

  return (
    <>
      <div className="bx--row">
        <div className="bx--col-lg-5 bx--col-xlg-4 bx--col-md-3 bx--col-sm-4 interactive-tour__intro-aside-sidebar">
          <div className="interactive-tour__intro-aside">
            {content.buttons.map((button: any) => {
              return (
                <button onClick={() => handleButtonClick(button.location)}>
                  <span>{button.title}</span>
                  <svg
                    focusable="false"
                    preserveAspectRatio="xMidYMid meet"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    aria-hidden="true"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    className="bx--btn__icon"
                  >
                    <path d="M9.3 3.7L13.1 7.5 1 7.5 1 8.5 13.1 8.5 9.3 12.3 10 13 15 8 10 3z"></path>
                  </svg>
                </button>
              );
            })}
          </div>
        </div>
        <div className="bx--col-lg-11 bx--col-xlg-12 bx--col-md-5 bx--col-sm-4 interactive-tour__intro-aside-content">
          <PublicImage
            imgPath={content.image}
            alt={content.imageAlt.props.defaultMessage}
            width={'100%'}
            widgetId={content.widgetId}
          />
        </div>
      </div>
    </>
  );
};

export default Intro;
